import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper, Typography, Container } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import VATSettings from '../components/VATSettings';
import ProductCategories from '../components/ProductCategories';
import EmailTemplates from './../components/EmailTemplates';
import ProductBrand from '../components/ProductBrand'; // ✅ Import ProductBrand
import PaymentMethod from '../components/PaymentMethod'; // ✅ Import PaymentMethod
import DocumentNoteTemplates from '../components/DocumentNoteTemplates';

const tabList = [
  { label: 'VAT Settings', value: 'vat' },
  { label: 'Product Categories', value: 'categories' },
  { label: 'Product Brands', value: 'brands' }, // ✅ Add Product Brands tab
  { label: 'Payment Methods', value: 'payments'}, // ✅ Disabled Payment Methods tab
  { label: 'Email Templates', value: 'email' },
  { label: 'Document Notes Templates', value: 'notes' },
];

const CompanySettingsPage = () => {
  const [tab, setTab] = useState('vat');

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          borderRadius: 3,
          background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.2) 100%)',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <BusinessIcon sx={{ fontSize: 40, color: '#667eea', mr: 2 }} />
          <Box>
            <Typography variant="h4" fontWeight="700" sx={{ color: '#667eea' }}>
              Company Settings
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Configure your company preferences and settings
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          overflow: 'hidden',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
        }}
      >
        <Box sx={{ display: 'flex', minHeight: 500 }}>
          <Paper
            elevation={0}
            sx={{
              minWidth: 220,
              borderRight: '1px solid rgba(0,0,0,0.08)',
              borderRadius: 0,
            }}
          >
            <Tabs
              orientation="vertical"
              value={tab}
              onChange={(e, v) => setTab(v)}
              sx={{
                '& .MuiTab-root': {
                  alignItems: 'flex-start',
                  textAlign: 'left',
                  px: 3,
                  py: 2,
                  fontSize: '0.95rem',
                  fontWeight: 500,
                  color: '#2d3748',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(102, 126, 234, 0.08)',
                  },
                  '&.Mui-selected': {
                    color: '#667eea',
                    fontWeight: 600,
                    backgroundColor: 'rgba(102, 126, 234, 0.1)',
                    borderRight: '3px solid #667eea',
                  },
                },
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
              }}
            >
              {tabList.map(t => (
                <Tab 
                  key={t.value} 
                  label={t.label} 
                  value={t.value} 
                />
              ))}
            </Tabs>
          </Paper>
          <Box sx={{ flex: 1, p: 3, width: '100%', backgroundColor: '#fafafa' }}>
            {tab === 'vat' && <VATSettings />}
            {tab === 'categories' && <ProductCategories />}
            {tab === 'brands' && <ProductBrand />} {/* ✅ Add ProductBrand component */}
            {tab === 'payments' && <PaymentMethod />} {/* ✅ Add PaymentMethod component */}
            {tab === 'notes' && <DocumentNoteTemplates />}
            {tab === 'email' && <EmailTemplates />}
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default CompanySettingsPage;